(ns rothko.editor.mark.core)

(defn system-mark?
  [mark]
  (when (map? mark) (:system? mark)))

(defn mark-name
  [mark]
  (cond
    (map? mark) (:name mark)
    :else mark))

(defn ->appearances
  [marks]
  (map mark-name marks))
